export const SUPPORTED_FILES_INPUT_ACCEPT_VALUE = `application/pdf, image/*, .docx`;
